(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
class FaqSchema extends HTMLElement {
  connectedCallback() {
    const entities = this.#collectEntities();

    if (entities.length) {
      this.#injectSchema(entities);
    }
  }

  /** @returns {{ '@type': string, name: string, acceptedAnswer: { '@type': string, text: string } }[]} */
  #collectEntities() {
    const entities = [];

    for (const item of this.querySelectorAll('.faq-section__details')) {
      const question = item.querySelector('.faq-section__question')?.textContent?.trim();
      const answer = item.querySelector('.faq-section__answer')?.textContent?.trim();

      if (!question || !answer) continue;

      entities.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: { '@type': 'Answer', text: answer },
      });
    }

    return entities;
  }

  /** @param {{ '@type': string, name: string, acceptedAnswer: object }[]} entities */
  #injectSchema(entities) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities,
    });
    document.head.appendChild(script);
  }
}

if (!customElements.get('faq-schema')) {
  customElements.define('faq-schema', FaqSchema);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-configuration-showcase"] && !Shopify.designMode) return;
  try {
    
  class ProductConfigurationShowcase extends HTMLElement {
    #handleResize = () => {
      this.#syncMobileCollapse();
    };

    /** @param {string} v */
    #activeLabel(v) {
      return (v || '').trim();
    }

    connectedCallback() {
      this.#bindFilters();
      this.#bindShowMore();
      this.classList.add('product-configuration-showcase--ready');
      this.#syncMobileCollapse();
      window.addEventListener('resize', this.#handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.#handleResize);
    }

    #bindFilters() {
      const buttons = this.querySelectorAll('[data-pcf-filter]');
      const cards = this.querySelectorAll('[data-pcf-card]');
      if (!buttons.length || !cards.length) {
        return;
      }

      for (const button of buttons) {
        button.addEventListener('click', () => {
          const raw = button.dataset.pcfValue || '';
          const isAll = raw === 'all';
          for (const btn of buttons) {
            const pressed = btn === button;
            btn.classList.toggle('product-configuration-showcase__pill--active', pressed);
            btn.setAttribute('aria-pressed', String(pressed));
          }
          for (const card of cards) {
            const value = this.#activeLabel(card.dataset.pcfValue || '');
            if (isAll) {
              card.removeAttribute('hidden');
              continue;
            }
            if (!value) {
              card.setAttribute('hidden', '');
              continue;
            }
            if (this.#activeLabel(value) === this.#activeLabel(raw)) {
              card.removeAttribute('hidden');
            } else {
              card.setAttribute('hidden', '');
            }
          }
          this.#setExpanded(false);
          requestAnimationFrame(() => this.#syncMobileCollapse());
        });
      }
    }

    #bindShowMore() {
      const button = this.querySelector('[data-pcf-show-more]');
      if (!button) {
        return;
      }

      button.addEventListener('click', () => {
        this.#setExpanded(true);
      });
    }

    /** @param {boolean} isExpanded */
    #setExpanded(isExpanded) {
      const button = this.querySelector('[data-pcf-show-more]');
      this.classList.toggle('product-configuration-showcase--expanded', isExpanded);
      if (button) {
        button.setAttribute('aria-expanded', String(isExpanded));
      }
    }

    #syncMobileCollapse() {
      const grid = this.querySelector('[data-pcf-grid]');
      if (!grid) {
        return;
      }

      const cards = Array.from(grid.querySelectorAll('[data-pcf-card]')).filter((card) => !card.hasAttribute('hidden'));
      const firstCard = cards[0];
      if (!firstCard) {
        this.dataset.pcfCollapsible = 'false';
        this.#setExpanded(false);
        grid.style.removeProperty('--pcf-mobile-collapse-height');
        this.style.removeProperty('--pcf-mobile-fade-start');
        return;
      }

      const firstRowTop = firstCard.offsetTop;
      const firstRowCount = cards.filter((card) => Math.abs(card.offsetTop - firstRowTop) < 2).length || 1;
      const isCollapsible = cards.length > firstRowCount;
      this.dataset.pcfCollapsible = String(isCollapsible);

      if (!isCollapsible) {
        this.#setExpanded(false);
        grid.style.removeProperty('--pcf-mobile-collapse-height');
        this.style.removeProperty('--pcf-mobile-fade-start');
        return;
      }

      const rowGap = Number.parseFloat(window.getComputedStyle(grid).rowGap) || 0;
      const cardHeight = firstCard.getBoundingClientRect().height;
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const peekHeight = isDesktop ? Math.min(cardHeight * 0.32, 120) : Math.min(cardHeight * 0.16, 56);
      grid.style.setProperty('--pcf-mobile-collapse-height', `${Math.round(cardHeight + rowGap + peekHeight)}px`);
      this.style.setProperty('--pcf-mobile-fade-start', `${Math.round(cardHeight + rowGap)}px`);
    }
  }

  if (!customElements.get('product-configuration-showcase')) {
    customElements.define('product-configuration-showcase', ProductConfigurationShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
